module.exports = __webpack_public_path__ + "img/apropos_logo_small.32df42f9.svg";